import { AsyncTaskStatusUpdateEventType } from "@performyard/service-contracts";

import internalRequest from "./internal-base-request";

/**
 * Get active async tasks by name for the authenticated user.
 *
 * @param taskName - The name of the task to search for
 * @returns Array of active tasks matching the given name
 */
export const getActiveUserTasksByName = async (taskName: string): Promise<AsyncTaskStatusUpdateEventType[]> => {
	const [response] = await internalRequest<AsyncTaskStatusUpdateEventType[]>(
		`/v1/async-tasks/user?taskName=${encodeURIComponent(taskName)}`,
		{
			method: "GET",
		}
	);

	return response || [];
};

/**
 * Get active async tasks by name for the company (company-wide).
 *
 * @param taskName - The name of the task to search for
 * @returns Array of active tasks matching the given name
 */
export const getActiveCompanyTasksByName = async (taskName: string): Promise<AsyncTaskStatusUpdateEventType[]> => {
	const [response] = await internalRequest<AsyncTaskStatusUpdateEventType[]>(
		`/v1/async-tasks/company?taskName=${encodeURIComponent(taskName)}`,
		{
			method: "GET",
		}
	);

	return response || [];
};
